// import { ViewSupport41Component } from "../../../components/SupportSystem/ViewReports/ViewSupport41Component";
import { OperationReport41Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport41Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function ViewSupport41Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-1)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            {/* <ViewSupport41Component /> */}
            <OperationReport41Component />
            <Footer />
        </div>
    );
}
